<template>
  <fragment>
    <b-row>
      <b-col class="col-md-12 col-lg-8 offset-lg-2 d-flex align-items-start">
        <strong class="phairify-color-grey mr-2">{{ myValuesLabel }}:</strong>
        <div class="d-inline-block">
          <div v-for="(value, i) in values" :key="i">{{ value }}</div>
        </div>
      </b-col>
    </b-row>
  </fragment>
</template>

<script>
import { QUESTION_TYPES } from '@/store';

export default {
  name: 'PreferenceChartMyValues',
  props: {
    studyQuestion: {
      type: Object,
      required: true,
    },
  },
  computed: {
    values: function () {
      if (!this.studyQuestion.responses.results[0]) return [];
      let result = null;
      switch (this.studyQuestion.type) {
        case QUESTION_TYPES.YES_NO:
          return this.studyQuestion.responses.results[0].results[0].stats
            .my_value === 1
            ? ['Yes']
            : ['No'];
        case QUESTION_TYPES.SELECT_ONE:
          result = this.studyQuestion.responses.results[0].results.find(
            (r) => r.stats.my_value
          );
          if (!result) return [];
          return [result.variable.short_label || result.variable.input_label];
        case QUESTION_TYPES.SELECT_ANY:
          return this.studyQuestion.responses.results[0].results
            .filter((r) => r.stats.my_value)
            .map((r) => r.variable.short_label || r.variable.input_label);
        default:
          return [];
      }
    },
    myValuesLabel: function () {
      return Array.isArray(this.values) && this.values.length > 1
        ? 'My Study Selections'
        : 'My Study Selection';
    },
  },
};
</script>

<style scoped></style>
